import "idempotent-babel-polyfill";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { App } from "./App";
import {
  RootErrorBoundary,
  RootErrorBoundaryVariant,
} from "./error-boundary/root-error-boundary";

let elementToMountReactAppOn = document.querySelector(
  "[data-bbnt-new-checkout-2022-mybag]"
);
if (!elementToMountReactAppOn) {
  const successPageElementToMountReactAppOnForTheSuccessPageReactApp =
    document.querySelector("[data-bbnt-new-checkout-2022-success-page]");
  if (successPageElementToMountReactAppOnForTheSuccessPageReactApp) {
    elementToMountReactAppOn =
      successPageElementToMountReactAppOnForTheSuccessPageReactApp;
  }
}

if (elementToMountReactAppOn) {
  const rootErrorBoundaryVariant: RootErrorBoundaryVariant =
    elementToMountReactAppOn.matches("[data-bbnt-new-checkout-2022-success-page]") ||
    elementToMountReactAppOn.closest("body.checkout-onepage-success")
      ? "success"
      : "bag";
  ReactDOM.render(
    <RootErrorBoundary variant={rootErrorBoundaryVariant}>
      <App mountElement={elementToMountReactAppOn} />
    </RootErrorBoundary>,
    elementToMountReactAppOn
  );
}
